import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext,
} from "react";
import "./JobsTableList.css";
import Card from "../../../Common/Card/Card";
import AnimationPlayer from "../../../Common/Animation-Player/AnimationPlayer";
import BotReplyIcon from "../../../Assets/Images/VybogTAL GEN Icon White.svg";
import ThinkingBubble from "../../../Common/ThinkingBubble/ThinkingBubble";
import NojobsAnimation from "../../../Assets/Json/nodata-found-robot-animation.json";
import { Toast } from "../../../Common/Toast-Snackbar/ToastSnackbar";
import { get, post } from "../../../helper/Api_helper";
import { STREAMING_ENABLED } from "../../../helper/featureFlags";
import { useThinkingFallback } from "../../../helper/useThinkingFallback";
import { RECOVERY_FAILED_MESSAGE } from "../../../helper/chatRecovery";
import Badge from "@mui/material/Badge";
import {
  VYLABS_BASE_URL,
  GET_CANDIDATE_BY_ID,
  GET_RESUME_BY_ID,
  CREATE_CHAT_CHANNEL_URL,
  PROCESS_CANDIDATE_CONVERSATION,
  WEB_SOCKET_URL,
  GET_CURRENT_CONVERSATION_TITLE,
  VENDORS_SEARCH,
  GET_VENDOR_DETAILS_BY_ID,
  UPDATE_CANDIDATE_DETAILS,
  CHATBOT_EXECUTE_SCHEDULE_INTERVIEW,
} from "../../../helper/url_helper";
import SidePopup from "../../../Common/SidePopup/SidePopup";
import RecommendedSearchBox from "../../../Common/RecommendedSearchBox/RecommendedSearchBox.js";
import { useFormik } from "formik";
import { ConfirmationPopup } from "../../../Common/PopupStyles/PopupComponent.js";
import CandidateDetailsContainer from "../../../Common/Candidate-Details-Container/CandidateDetailsContainer.js";
import { v4 as uuidv4 } from "uuid";
import DynamicSkeleton from "../../../Common/Skeleton/Skeleton.jsx";
import CandidatesAssignJob from "../Candidates/CandidatesAssignJob.js";
import "../Candidates/Candidates.css";
import { DynamicContext } from "../../../Context/DynamicContext";
import Button from "../../../Common/Button/Button.js";
import calenderIcon from "../../../Assets/Images/calender-active-icon.png";
import timerIcon from "../../../Assets/Images/timer-active-icon.png";
import candidateNameIcon from "../../../Assets/Images/candidate-name-active-icon.png";
import candidateEmailIcon from "../../../Assets/Images/email-active-icon.png";
import interviewerIcon from "../../../Assets/Images/interviewer-active-icon.png";
import VybogTALLoaderAnimation from "../../../Common/Dynamic-Animations/DynamicAnimations.js";
import {
  parseMessageText,
  BotResponseStarIcon,
  renderInlineMarkdown,
  getBulletContent,
  renderBotContent,
} from "../../../Common/Common-Function/CommonFunctions";
import CustomTooltip from "../../../Common/Tooltip/Tooltip";
import VybogTALWhiteIcon from "../../../Assets/Images/VybogTAL GEN Icon White.svg";
import networkIcon from "../../../Assets/Images/Network-badge-icon.svg";
import MatchPercentage from "../../../Common/Match-percentage-popup/MatchPercentage";
import JobsBlastEmailCampaign from "../Candidates/JobsBlastEmailCampaign.js";
import EmailCampaignIcon from "../../../Assets/Images/Email-campaign-icon.svg";
import jobsBlastIcon from "../../../Assets/Images/jobs-blast-icon.svg";
export const candidatesCache = new Map();
export const channelIdCache = new Map();

function RecommendCandidates({
  jobActiveTab,
  jobId,
  jobTitle,
  hideSearchBox = false,
  isFetchingRecommendedCandidates = false,
  recommendedCandidateIds = [],
}) {
  const { setIsFromJobRecommendedCandidates, userDetails, isDarkMode } =
    useContext(DynamicContext);
  const [recommendedMessages, setRecommendedMessages] = useState([]);
  const [searchMessages, setSearchMessages] = useState([]);
  const [isBotProcessing, setIsBotProcessing] = useState(false);
  const [showAssignedTable, setShowAssignedTable] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [isSearchBoxCollapsed, setIsSearchBoxCollapsed] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [openConversationLimitPopup, setOpenConversationLimitPopup] =
    useState(false);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [cachedRecommendedCandidates, setCachedRecommendedCandidates] =
    useState([]);
  const [socket, setSocket] = useState(null);
  const [isAssignJobModalOpen, setAssignJobModalOpen] = useState(false);
  const [candidateToAssign, setCandidateToAssign] = useState(null);
  const [vendorList, setVendorList] = useState([]);
  const [vendorOptionLoading, setVendorOptionLoading] = useState(false);
  const [assignedVendor, setAssignedVendor] = useState(null);
  const [isEditingCandidate, setIsEditingCandidate] = useState(false);
  const [originalCandidateData, setOriginalCandidateData] = useState(null);
  const [editedCandidateData, setEditedCandidateData] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);
  const [isAllCandidatesActive, setIsAllCandidatesActive] = useState(true);
  const [allCanList, setAllCanList] = useState([]);
  const [myCanList, setMyCanList] = useState([]);
  const [interviewDecoratorData, setInterviewDecoratorData] = useState(null);
  const [interviewSchedulingStatus, setInterviewSchedulingStatus] = useState(
    new Map(),
  );
  const [isSelectMode, setIsSelectMode] = useState(false);
  const [selectedChatCan, setSelectedChatCan] = useState([]);
  const [showMatchPercentagePopup, setShowMatchPercentagePopup] =
    useState(false);
  const [isJobBlastSelectModeActive, setIsJobBlastSelectModeActive] = useState(false);
  const [isEmailCampaignPopupOpen, setIsEmailCampaignPopupOpen] = useState(false);
  const [isEmailPreviewOpen, setIsEmailPreviewOpen] = useState(false);
  const [canPreview, setCanPreview] = useState(false);
  const debounceTimeoutRef = useRef(null);
  const messagesEndRef = useRef(null);
  const socketRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const pingIntervalRef = useRef(null);
  const pingTimeoutRef = useRef(null);
  const responseReceivedRef = useRef(false);
  const isConnectingRef = useRef(false);
  const lastMessageRef = useRef(null);
  const messageQueueRef = useRef([]);
  const lastPingTimeRef = useRef(null);
  const recommendedChannelIdRef = useRef(null);

  const isAwaitingReply =
    searchMessages.some((m) => m.isLoading) ||
    recommendedMessages.some((m) => m.isLoading);
  const resolveLoadingMessages = (text) => {
    const apply = (setFn) =>
      setFn((prev) => {
        const idx = prev.findIndex((m) => m.isLoading || m.isStreaming);
        if (idx === -1) return prev;
        const updated = [...prev];
        updated[idx] = {
          ...updated[idx],
          text,
          isLoading: false,
          isStreaming: false,
        };
        return updated;
      });
    apply(setSearchMessages);
    apply(setRecommendedMessages);
    responseReceivedRef.current = true;
    setIsBotProcessing(false);
  };
  useThinkingFallback({
    active: isAwaitingReply,
    getChannelId: () => recommendedChannelIdRef.current,
    responseReceivedRef,
    onRecovered: (answer) => resolveLoadingMessages(answer),
    onExhausted: () => resolveLoadingMessages(RECOVERY_FAILED_MESSAGE),
  });

  const MAX_RECONNECT_ATTEMPTS = 5;
  const BASE_RECONNECT_DELAY = 1000;
  const PING_INTERVAL = 30000;
  const PING_TIMEOUT = 10000;
  const formik = useFormik({
    initialValues: {
      askmeanything: "",
    },
  });

  const setInterviewStatus = (messageId, status) => {
    setInterviewSchedulingStatus((prev) =>
      new Map(prev).set(messageId, status),
    );
  };

  const handleToggleSelectMode = () => {
    setIsSelectMode((prev) => {
      if (prev) {
        setSelectedChatCan([]);
      }
      return !prev;
    });
  };

  const handleToggleJobBlastSelectMode = () => {
    setIsJobBlastSelectModeActive(true);
    setIsSelectMode((prev) => {
      if (prev) {
        setSelectedChatCan([]);
      }
      return !prev;
    });
  };

  const handleCardSelect = (candidate, event) => {
    event && event.stopPropagation();

    setSelectedChatCan((prev) => {
      if (prev.some((c) => c.id === candidate.id)) {
        return prev.filter((c) => c.id !== candidate.id);
      } else {
        if (prev.length >= 10) {
          Toast("error", "You can Select only upto 10 candidates.");
          return prev;
        }
        return [...prev, candidate];
      }
    });
  };

  const handleSelectAllRecommendedCandidates = (candidates = []) => {
    const topFitCandidates = candidates.filter(
      (candidate) => String(candidate?.fitness || "").toLowerCase() === "top",
    );
    const selectableCandidateIds = new Set(
      topFitCandidates.map((candidate) => candidate.id),
    );
    const selectedCandidateIds = new Set(
      selectedChatCan.map((candidate) => candidate.id),
    );
    const areAllSelectableCandidatesSelected =
      topFitCandidates.length > 0 &&
      topFitCandidates.every((candidate) =>
        selectedCandidateIds.has(candidate.id),
      );

    if (areAllSelectableCandidatesSelected) {
      setSelectedChatCan((prev) =>
        prev.filter((candidate) => !selectableCandidateIds.has(candidate.id)),
      );
      return;
    }

    if (topFitCandidates.length === 0) {
      Toast("error", "No top fit candidates available to select.");
      return;
    }

    setSelectedChatCan(topFitCandidates);
  };

  const getInterviewStatus = (messageId) => {
    return (
      interviewSchedulingStatus.get(messageId) || {
        isScheduling: false,
        isScheduled: false,
      }
    );
  };

  const isInterviewScheduled = (messageId) => {
    return getInterviewStatus(messageId).isScheduled;
  };

  const isInterviewScheduling = (messageId) => {
    return getInterviewStatus(messageId).isScheduling;
  };
  const scheduleInterview = async (messageId, decoratorData) => {
    if (!decoratorData) {
      Toast("error", "No interview data available");
      return;
    }
    if (isInterviewScheduling(messageId) || isInterviewScheduled(messageId)) {
      return;
    }
    setInterviewStatus(messageId, { isScheduling: true, isScheduled: false });

    try {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const response = await post(
        VYLABS_BASE_URL,
        CHATBOT_EXECUTE_SCHEDULE_INTERVIEW,
        {
          event_args: JSON.stringify(decoratorData.parsedEventArgs),
          event_type: decoratorData.type,
          message_id: decoratorData.message_id,
          timezone: userTimezone,
        },
      );
      if (response === "executed") {
        setInterviewStatus(messageId, {
          isScheduling: false,
          isScheduled: true,
        });
        Toast("success", "Interview scheduled successfully!");
      } else {
        setInterviewStatus(messageId, {
          isScheduling: false,
          isScheduled: false,
        });
        Toast("error", "Failed to schedule interview");
      }
    } catch (error) {
      console.error("scheduleInterview error Response", error);
      setInterviewStatus(messageId, {
        isScheduling: false,
        isScheduled: false,
      });
      Toast("error", "Error scheduling interview");
    }
  };

  const cancelInterview = (messageId) => {
    const confirmCancel = window.confirm(
      "Are you sure you want to cancel this interview scheduling?",
    );
    if (confirmCancel) {
      setInterviewStatus(messageId, {
        isScheduling: false,
        isScheduled: false,
      });
    }
  };
  const fetchResumesList = useCallback(
    async (resumes = [], botMessageId, isSearch = false) => {
      setIsBotProcessing(true);
      try {
        const detailedResumes = await Promise.all(
          resumes.map(async (resume) => {
            if (resume.candidate_id) {
              try {
                const res = await get(
                  VYLABS_BASE_URL,
                  `${GET_CANDIDATE_BY_ID}?id=${resume.candidate_id}`,
                );
                return {
                  ...res.candidate,
                  parsed_resume: JSON.parse(res.candidate.parsed_resume),
                  isFileBased: false,
                };
              } catch (err) {
                console.error("Error fetching candidate by ID:", err);
                return null;
              }
            } else {
              try {
                const res = await get(
                  VYLABS_BASE_URL,
                  `${GET_RESUME_BY_ID}?file_id=${resume.file_id}`,
                );
                return {
                  ...res.file,
                  parsed_resume: JSON.parse(res.file.parsed_resume),
                  isFileBased: true,
                  id: res.file.id,
                };
              } catch (err) {
                console.error("Error fetching resume by file ID:", err);
                return null;
              }
            }
          }),
        );
        const filteredResumes = detailedResumes.filter(Boolean);

        if (!isSearch) {
          setCachedRecommendedCandidates(filteredResumes);
          candidatesCache.set(jobId, filteredResumes);
        }

        const updateMessages = (prev, isSearch) => {
          const updated = [...prev];
          const botMessageIndex = updated.findIndex(
            (msg) => msg.id === botMessageId && msg.sender === "bot",
          );

          if (botMessageIndex !== -1) {
            updated[botMessageIndex] = {
              ...updated[botMessageIndex],
              isLoading: false,
              resumes: filteredResumes,
            };
          }

          return updated;
        };

        if (isSearch) {
          setSearchMessages((prev) => updateMessages(prev, true));
          if (filteredResumes.length === 0) {
            setSearchMessages((prev) => {
              const updated = [...prev];
              const botMessageIndex = updated.findIndex(
                (msg) => msg.id === botMessageId && msg.sender === "bot",
              );
              if (botMessageIndex !== -1) {
                updated[botMessageIndex] = {
                  ...updated[botMessageIndex],
                  text: "No matching candidates found.",
                  isLoading: false,
                  resumes: [],
                };
              }
              return updated;
            });
          }
        } else {
          setRecommendedMessages((prev) => updateMessages(prev, false));
        }
        setIsBotProcessing(false);
      } catch (error) {
        console.error("Error in fetchResumesList:", error);
        setSearchMessages((prev) => {
          const updated = [...prev];
          const botMessageIndex = updated.findIndex(
            (msg) => msg.id === botMessageId && msg.sender === "bot",
          );
          if (botMessageIndex !== -1) {
            updated[botMessageIndex] = {
              ...updated[botMessageIndex],
              text: "Error fetching candidate details.",
              isLoading: false,
              resumes: [],
            };
          }
          return updated;
        });
      }
    },
    [jobId],
  );
  const fetchCandidateForInterview = async (candidateId) => {
    try {
      const res = await get(
        VYLABS_BASE_URL,
        `${GET_CANDIDATE_BY_ID}?id=${candidateId}`,
      );
      return {
        id: res.candidate.id,
        name: res.candidate.name,
        email: res.candidate.email,
      };
    } catch (error) {
      console.error("Error fetching candidate for interview:", error);
      return null;
    }
  };
  const handleReconnect = useCallback(() => {
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      Toast("error", "Max reconnection attempts reached. Please refresh.");
      setSearchMessages((prev) => {
        const updated = [...prev];
        const loadingIndex = updated.findIndex((msg) => msg.isLoading);
        if (loadingIndex !== -1) {
          updated[loadingIndex] = {
            ...updated[loadingIndex],
            text: "Connection failed. Please try again.",
            isLoading: false,
            resumes: [],
          };
        }
        return updated;
      });
      return;
    }
    const delay = Math.min(
      BASE_RECONNECT_DELAY * Math.pow(2, reconnectAttempts) +
        Math.random() * 1000,
      30000,
    );
    reconnectTimeoutRef.current = setTimeout(() => {
      setReconnectAttempts((prev) => prev + 1);
      initializeWebSocket();
    }, delay);
  }, [reconnectAttempts]);

  const parseNestedJSON = (str) => {
    try {
      if (str === "reading message" || str === '"reading message"') {
        return null;
      }
      const cleanedStr = str
        .replace(/^"+|"+$/g, "")
        .replace(/\\"/g, '"')
        .replace(/\\\\/g, "\\");
      const parsed = JSON.parse(cleanedStr);
      if (!parsed || typeof parsed !== "object") {
        throw new Error("Parsed response is not a valid object");
      }
      return parsed;
    } catch (error) {
      console.error("Failed to parse WebSocket message:", error, { raw: str });
      return null;
    }
  };
  const initializeWebSocket = useCallback(() => {
    if (isConnectingRef.current) {
      console.log("Already attempting to connect, skipping...");
      return;
    }
    isConnectingRef.current = true;
    if (socketRef.current) {
      socketRef.current.close();
    }
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
      pingIntervalRef.current = null;
    }
    if (pingTimeoutRef.current) {
      clearTimeout(pingTimeoutRef.current);
      pingTimeoutRef.current = null;
    }
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }
    responseReceivedRef.current = false;

    const token = localStorage.getItem("token");
    const wsProtocol =
      window.location.protocol === "https:" ? "wss://" : "wss://";
    const wsUrl = `${wsProtocol}${WEB_SOCKET_URL}/ws?token=${encodeURIComponent(
      "Bearer " + token,
    )}`;

    try {
      console.log("Creating new WebSocket connection...");
      const ws = new WebSocket(wsUrl);
      socketRef.current = ws;
      setSocket(ws);

      ws.onopen = () => {
        console.log("WebSocket connection established");
        setReconnectAttempts(0);
        isConnectingRef.current = false;
        if (lastMessageRef.current) {
          console.log("Resending last message:", lastMessageRef.current);
          ws.send(lastMessageRef.current);
        }
        if (messageQueueRef.current.length > 0) {
          console.log(
            `Processing ${messageQueueRef.current.length} queued messages`,
          );
          messageQueueRef.current.forEach((msg) => {
            if (ws.readyState === WebSocket.OPEN) {
              ws.send(msg);
            }
          });
          messageQueueRef.current = [];
        }
        startPingInterval(ws);
      };

      ws.onmessage = async (event) => {
        if (event.data === "pong") {
          console.log("Pong received");
          if (pingTimeoutRef.current) {
            clearTimeout(pingTimeoutRef.current);
            pingTimeoutRef.current = null;
          }
          return;
        }

        try {
          console.log("WebSocket response received:", event.data);
          const separatorIndex = event.data.indexOf("|");
          if (separatorIndex === -1) {
            return;
          }
          const topic = event.data.substring(0, separatorIndex);
          const payload = event.data.substring(separatorIndex + 1);
          const trimmedTopic = topic.split(":")[0].trim();
          if (trimmedTopic === "screening-message-delta") {
            if (!STREAMING_ENABLED) return;
            let chunk = "";
            try {
              chunk = JSON.parse(payload);
            } catch (e) {
              chunk = payload;
            }
            if (typeof chunk !== "string") {
              chunk = chunk == null ? "" : String(chunk);
            }
            if (chunk) {
              setSearchMessages((prev) => {
                const updated = [...prev];
                const idx = updated.findIndex(
                  (m) => m.isLoading || m.isStreaming,
                );
                if (idx !== -1) {
                  updated[idx] = {
                    ...updated[idx],
                    text: (updated[idx].text || "") + chunk,
                    isLoading: false,
                    isStreaming: true,
                  };
                }
                return updated;
              });
            }
            return;
          }
          const response = parseNestedJSON(payload);
          if (!response) {
            return;
          }
          const isNoCandidatesResponse =
            response.answer === "No matching candidates found.";
          let candidateDetails = null;
          if (
            response.decorator &&
            response.decorator.type === "interview_schedule"
          ) {
            let eventArgs = response.decorator.event_args;
            if (typeof eventArgs === "string") {
              try {
                eventArgs = JSON.parse(eventArgs);
              } catch (error) {
                console.error("Failed to parse event_args:", error);
              }
            }

            if (eventArgs && eventArgs.candidate_id) {
              try {
                candidateDetails = await fetchCandidateForInterview(
                  eventArgs.candidate_id,
                );
                console.log("Fetched candidate details:", candidateDetails);
              } catch (error) {
                console.error("Error fetching candidate details:", error);
                candidateDetails = { name: "N/A", email: "N/A" };
              }
            }
          }
          setSearchMessages((prev) => {
            const updated = [...prev];
            const loadingIndex = updated.findIndex(
              (msg) => msg.isLoading || msg.isStreaming,
            );

            if (
              trimmedTopic === "screening-send-message-completed" ||
              trimmedTopic === "screening-message-update"
            ) {
              console.log("Processing screening response:", response);
              responseReceivedRef.current = true;

              let decoratorData = null;

              if (
                response.decorator &&
                response.decorator.type === "interview_schedule"
              ) {
                let eventArgs = response.decorator.event_args;
                if (typeof eventArgs === "string") {
                  try {
                    eventArgs = JSON.parse(eventArgs);
                  } catch (error) {
                    console.error("Failed to parse event_args:", error);
                  }
                }

                decoratorData = {
                  ...response.decorator,
                  parsedEventArgs: eventArgs,
                  message_id: response.message_id,
                  candidateDetails: candidateDetails || {
                    name: "N/A",
                    email: "N/A",
                  },
                };
                setInterviewDecoratorData(decoratorData);
              }

              if (isNoCandidatesResponse) {
                if (loadingIndex !== -1) {
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    text: response.answer,
                    isLoading: false,
                    isStreaming: false,
                    resumes: [],
                    decorator: decoratorData,
                  };
                } else {
                  const newMessageId = uuidv4();
                  updated.push({
                    id: newMessageId,
                    sender: "bot",
                    text: response.answer,
                    isLoading: false,
                    resumes: [],
                    decorator: decoratorData,
                  });
                }
              } else {
                const similarResumes = [];
                const lines = response.answer
                  .split("\n")
                  .filter((line) => line.trim());
                let messageText = "";
                lines.forEach((line) => {
                  const candidateIdMatch = line.match(
                    /Candidate ID:\s*([a-f0-9]+)/,
                  );
                  if (candidateIdMatch) {
                    similarResumes.push({
                      candidate_id: candidateIdMatch[1],
                    });
                  } else if (line.trim() && !line.match(/^\s*$/)) {
                    messageText += line.trim() + "\n";
                  }
                });

                messageText = messageText.trim();

                if (loadingIndex !== -1) {
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    text: messageText,
                    isLoading: false,
                    isStreaming: false,
                    resumes: similarResumes,
                    decorator: decoratorData,
                  };

                  if (similarResumes.length > 0) {
                    fetchResumesList(
                      similarResumes,
                      updated[loadingIndex].id,
                      true,
                    );
                  }
                } else {
                  const newMessageId = uuidv4();
                  updated.push({
                    id: newMessageId,
                    sender: "bot",
                    text: messageText,
                    isLoading: false,
                    resumes: similarResumes,
                    decorator: decoratorData,
                  });

                  if (similarResumes.length > 0) {
                    fetchResumesList(similarResumes, newMessageId, true);
                  }
                }
              }
            } else if (trimmedTopic === "screening-total-tokens-err") {
              console.log("Token limit exceeded:", response);
              setOpenConversationLimitPopup(true);
              responseReceivedRef.current = true;
            } else {
              console.warn("Unhandled topic received:", topic);
            }

            console.log("Updated searchMessages:", updated);
            return updated;
          });

          setIsBotProcessing(false);

          if (responseReceivedRef.current && ws.readyState === WebSocket.OPEN) {
            setTimeout(() => {
              ws.close(1000, "Response received, closing connection");
            }, 1000);
          }
        } catch (error) {
          console.error("Error processing WebSocket message:", error);
        }
      };

      ws.onclose = (event) => {
        console.log("WebSocket connection closed", event);
        isConnectingRef.current = false;
        if (pingIntervalRef.current) {
          clearInterval(pingIntervalRef.current);
          pingIntervalRef.current = null;
        }
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
          pingTimeoutRef.current = null;
        }
        if (
          event.code === 1006 ||
          (!responseReceivedRef.current && event.code !== 1000)
        ) {
          console.log(
            `Connection closed with code ${event.code}, attempting to reconnect...`,
          );
          handleReconnect();
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        isConnectingRef.current = false;
        setIsBotProcessing(true);
        handleReconnect();
      };
    } catch (error) {
      console.error("Error creating WebSocket:", error);
      isConnectingRef.current = false;
      handleReconnect();
    }
  }, [handleReconnect, fetchResumesList]);

  const startPingInterval = useCallback((ws) => {
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
    }
    if (ws.readyState === WebSocket.OPEN) {
      console.warn("Sending initial ping");
      ws.send("ping");
      lastPingTimeRef.current = Date.now();
      pingTimeoutRef.current = setTimeout(() => {
        const timeSinceLastPing = Date.now() - lastPingTimeRef.current;
        if (timeSinceLastPing > PING_TIMEOUT) {
          console.log("No pong received within timeout, reconnecting...");
          ws.close(1000, "Ping timeout");
        }
      }, PING_TIMEOUT);
    }
    pingIntervalRef.current = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        console.warn("Sending ping");
        ws.send("ping");
        lastPingTimeRef.current = Date.now();
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
        }
        pingTimeoutRef.current = setTimeout(() => {
          const timeSinceLastPing = Date.now() - lastPingTimeRef.current;
          if (timeSinceLastPing > PING_TIMEOUT) {
            console.log("No pong received within timeout, reconnecting...");
            ws.close(1000, "Ping timeout");
          }
        }, PING_TIMEOUT);
      }
    }, PING_INTERVAL);
  }, []);

  const fetchRecommendedCandidates = useCallback(async () => {
    if (candidatesCache.has(jobId)) {
      const cached = candidatesCache.get(jobId);
      // Drop "unlikely" fitness tiers: poor matches aren't surfaced as
      // recommendations. Untiered items (rerank fallback/timeout) are kept so
      // the tab degrades gracefully to threshold labels instead of going empty.
      const cachedCandidates = (cached || []).filter(
        (c) => String(c?.fitness || "").toLowerCase() !== "unlikely",
      );

      if (!cachedCandidates || cachedCandidates.length === 0) {
        setRecommendedMessages([
          {
            id: uuidv4(),
            sender: "user",
            text: "Searching for recommended candidates",
          },
          {
            id: uuidv4(),
            sender: "bot",
            text: "No recommended candidates found.",
            isLoading: false,
            resumes: [],
            isFirstResponse: false,
          },
        ]);
        setCachedRecommendedCandidates([]);
        setIsBotProcessing(false);
        return;
      }
      setCachedRecommendedCandidates(cachedCandidates);
      setRecommendedMessages([
        {
          id: uuidv4(),
          sender: "user",
          text: "Searching for recommended candidates",
        },
        {
          id: uuidv4(),
          sender: "bot",
          text: "Here are some recommended candidates:",
          isLoading: false,
          resumes: cachedCandidates,
          isFirstResponse: false,
        },
      ]);
      setIsBotProcessing(false);
    } else {
      setRecommendedMessages([
        {
          id: uuidv4(),
          sender: "bot",
          text: "",
          isLoading: true,
          resumes: [],
        },
      ]);
      setCachedRecommendedCandidates([]);
    }
  }, [jobId]);

  useEffect(() => {
    if (jobActiveTab === "Recommended Candidates") {
      fetchRecommendedCandidates();
    } else {
      setRecommendedMessages([]);
      setCachedRecommendedCandidates([]);
    }
  }, [
    jobActiveTab,
    fetchRecommendedCandidates,
    jobId,
    isFetchingRecommendedCandidates,
  ]);

  const handleCandidateConversation = useCallback(async () => {
    const { askmeanything } = formik.values;
    if (!askmeanything?.trim()) {
      Toast("error", "Please provide a search query.");
      return;
    }
    if (selectedChatCan.length === 0) {
      Toast("error", "You have to select atleast 1 candidate.");
      return;
    }
    setHasSearched(true);
    setShowAssignedTable(false);
    setIsBotProcessing(true);

    const messageId = uuidv4();
    const botMessageId = uuidv4();
    const recommendedBotMessage = recommendedMessages.find(
      (msg) => msg.sender === "bot",
    );
    let recommendedCandidates = recommendedBotMessage?.resumes || [];
    if (selectedChatCan.length > 0) {
      recommendedCandidates = recommendedCandidates.filter((candidate) =>
        selectedChatCan.some((selected) => selected.id === candidate.id),
      );
    }
    const isFirstSearchMessage = searchMessages.length === 0;

    if (!hasSearched) {
      setSearchMessages([
        {
          id: uuidv4(),
          sender: "user",
          text: "recommended candidates for this job",
        },
        {
          id: uuidv4(),
          sender: "bot",
          text: "",
          isLoading: false,
          resumes: recommendedCandidates,
        },
        {
          id: messageId,
          sender: "user",
          text: askmeanything,
        },
        {
          id: botMessageId,
          sender: "bot",
          text: "",
          isLoading: true,
          resumes: [],
        },
      ]);
    } else {
      setSearchMessages((prev) => [
        ...prev,
        {
          id: messageId,
          sender: "user",
          text: askmeanything,
        },
        {
          id: botMessageId,
          sender: "bot",
          text: "",
          isLoading: true,
          resumes: [],
        },
      ]);
    }

    try {
      let currentChannelID = recommendedChannelIdRef.current;
      if (!currentChannelID && !hasSearched) {
        const createChatChannelResponse = await post(
          VYLABS_BASE_URL,
          CREATE_CHAT_CHANNEL_URL,
          { chat_channel_type: "candidate" },
        );
        currentChannelID = createChatChannelResponse.ID;
        recommendedChannelIdRef.current = currentChannelID;
        channelIdCache.set(jobId, currentChannelID);

        await post(VYLABS_BASE_URL, GET_CURRENT_CONVERSATION_TITLE, {
          chat_channel_id: currentChannelID,
          message: "Recommended Candidates for " + jobTitle,
        });
      } else if (!currentChannelID) {
        currentChannelID = channelIdCache.get(jobId);
        if (!currentChannelID) {
          console.error("No channel ID available for conversation");
          setSearchMessages((prev) => {
            const updated = [...prev];
            const loadingIndex = updated.findIndex((msg) => msg.isLoading);
            if (loadingIndex !== -1) {
              updated[loadingIndex] = {
                sender: "system",
                text: "Error: No chat channel available. Please try again.",
                isLoading: false,
                resumes: [],
              };
            }
            return updated;
          });
          setIsBotProcessing(false);
          return;
        }
        recommendedChannelIdRef.current = currentChannelID;
      }

      const formData = new FormData();
      formData.append("channel_id", currentChannelID);
      formData.append("message_content", askmeanything);
      if (isFirstSearchMessage) {
        if (selectedChatCan && selectedChatCan.length > 0) {
          formData.append(
            "candidate_id",
            JSON.stringify(selectedChatCan.map((c) => c.id)),
          );
        }
      }

      await post(VYLABS_BASE_URL, PROCESS_CANDIDATE_CONVERSATION, formData);
      initializeWebSocket();
    } catch (error) {
      console.error("Error in candidate conversation:", error);
      if (
        error.response?.data &&
        error.response.data.includes("chat channel is blocked")
      ) {
        setSearchMessages((prev) =>
          prev.filter((msg) => msg.id !== messageId && msg.id !== botMessageId),
        );
        setOpenConversationLimitPopup(true);
      } else {
        setSearchMessages((prev) => {
          const updated = [...prev];
          const loadingIndex = updated.findIndex((msg) => msg.isLoading);
          if (loadingIndex !== -1) {
            updated[loadingIndex] = {
              sender: "system",
              text: "Error processing request. Please try again.",
              isLoading: false,
              resumes: [],
            };
          }
          return updated;
        });
      }
    } finally {
      formik.resetForm();
    }
  }, [
    formik.values,
    initializeWebSocket,
    jobId,
    jobTitle,
    recommendedMessages,
    hasSearched,
    recommendedCandidateIds,
    searchMessages.length,
    isSelectMode,
    selectedChatCan,
  ]);

  const fetchCandidateById = useCallback(async (id) => {
    try {
      const res = await get(VYLABS_BASE_URL, `${GET_CANDIDATE_BY_ID}?id=${id}`);
      const candidate = res?.candidate;
      const candidatefiles = res?.files;
      const parsedResumeData = candidate?.parsed_resume
        ? JSON.parse(candidate.parsed_resume)
        : null;
      const presignedUrl =
        candidatefiles && candidatefiles.length > 0
          ? candidatefiles[0].presigned_url
          : null;

      const updatedCandidate = {
        ...candidate,
        secondaryEmail: candidate.secondary_email,
        secondaryPhone: candidate.secondary_phone,
        vendorID: candidate.vendor_id,
        lineAddress1: candidate.line_address_1,
        lineAddress2: candidate.line_address_2,
        preferredSalary: candidate.preferred_salary,
        zipCode: candidate.zip_code,
        parsedResumeData,
        files: candidatefiles || null,
        presignedUrl,
        isFileBased: false,
        avatar: res?.profile_img_url,
      };
      if (updatedCandidate.vendorID) {
        try {
          const vendorResponse = await get(
            VYLABS_BASE_URL,
            `${GET_VENDOR_DETAILS_BY_ID}?id=${updatedCandidate.vendorID}`,
          );
          setAssignedVendor(vendorResponse);
          updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
        } catch (err) {
          console.error("Error fetching vendor details:", err);
          updatedCandidate.vendorDetails = null;
        }
      } else {
        updatedCandidate.vendorDetails = null;
      }
      setSelectedCandidate(updatedCandidate);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching candidate:", error);
      Toast("error", error.response.data || "Failed to fetch candidate details.");
    }
  }, []);

  const handleCardView = useCallback(
    (candidate) => {
      setIsFromJobRecommendedCandidates(true);
      if (!candidate.isFileBased) {
        fetchCandidateById(candidate.id);
      } else {
        setSelectedCandidate({
          ...candidate,
          parsedResumeData: candidate.parsed_resume,
          BasicInfo: {
            Name: candidate.parsed_resume?.BasicInfo?.Name || "N/A",
            Email: candidate.parsed_resume?.BasicInfo?.Email || "N/A",
            PhoneNumber:
              candidate.parsed_resume?.BasicInfo?.PhoneNumber || "N/A",
            CurrentLocationCity:
              candidate.parsed_resume?.BasicInfo?.CurrentLocationCity || "N/A",
            YearsOfExperience:
              candidate.parsed_resume?.BasicInfo?.YearsOfExperience || "N/A",
            CurrentJobTitle:
              candidate.parsed_resume?.BasicInfo?.CurrentJobTitle ||
              "Not specified",
          },
          isFileBased: true,
        });
        setIsModalOpen(true);
      }
    },
    [fetchCandidateById, setIsFromJobRecommendedCandidates],
  );

  const handleAssignJobModal = useCallback((candidate) => {
    setCandidateToAssign(candidate);
    setAssignJobModalOpen(true);
  }, []);

  const handleClearSearch = () => {
    setSearchMessages([]);
    setHasSearched(false);
    setShowAssignedTable(true);
    recommendedChannelIdRef.current = null;
    channelIdCache.delete(jobId);
    formik.resetForm();
    if (socketRef.current) {
      socketRef.current.close();
    }
  };

  useEffect(() => {
    return () => {
      setIsFromJobRecommendedCandidates(false);
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      if (socketRef.current) {
        socketRef.current.close();
      }
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
      }
      if (pingTimeoutRef.current) {
        clearTimeout(pingTimeoutRef.current);
      }
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [searchMessages, recommendedMessages]);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setActiveTab(0);
    setSelectedCandidate(null);
    resetCandidateEdit();
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const renderBotResponse = (message) => {
    if (message.sender !== "bot") return null;

    const { summary, skillsLines, educationLines } = parseMessageText(
      message.text,
    );

    return (
      <div className="bot-message-container">
        <img src={BotReplyIcon} alt="BotReplyIcon" className="replay-icon" />
        <div
          className="bot-message-content"
          style={
            message.isLoading
              ? { border: "none" }
              : {
                  border: "1px solid var(--border__color)",
                  padding: "15px",
                  borderRadius: "8px",
                }
          }
        >
          {isBotProcessing && message.isLoading ? (
            <ThinkingBubble />
          ) : (
            <div className="message-and-cards-container">
              {summary && (
                <div className="summary-container">
                  {summary.split("\n").map((line, idx) => {
                    const trimmedLine = line.trim();
                    const bulletContent = getBulletContent(trimmedLine);
                    if (bulletContent !== null) {
                      return (
                        <div
                          key={idx}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            marginBottom: "5px",
                          }}
                        >
                          <img
                            src={BotResponseStarIcon}
                            alt="bullet"
                            style={{
                              width: "18px",
                              height: "18px",
                              marginRight: "8px",
                              marginTop: "10px",
                              flexShrink: 0,
                            }}
                          />
                          <span
                            className="summary-text"
                            style={{ whiteSpace: "pre-wrap" }}
                          >
                            {renderInlineMarkdown(bulletContent)}
                          </span>
                        </div>
                      );
                    }
                    return (
                      <p
                        key={idx}
                        className="summary-text"
                        style={{
                          whiteSpace: "pre-wrap",
                          marginBottom: "5px",
                          marginTop: "0px",
                          minHeight: line.trim() ? "auto" : "1em",
                        }}
                      >
                        {renderBotContent(line)}
                      </p>
                    );
                  })}
                  {message.isStreaming && (
                    <>
                      <style>{`@keyframes vyblink{0%,100%{opacity:1}50%{opacity:0}}`}</style>
                      <span
                        style={{
                          display: "inline-block",
                          width: "7px",
                          height: "16px",
                          marginLeft: "2px",
                          background: "var(--chat-text)",
                          animation: "vyblink 1s steps(1) infinite",
                          verticalAlign: "text-bottom",
                        }}
                      />
                    </>
                  )}
                </div>
              )}
              {educationLines.length > 0 && (
                <div className="education-container">
                  <h4 className="education-title">Education Details</h4>
                  {educationLines.map((edu, idx) => (
                    <div
                      key={idx}
                      className="education-item"
                      style={{ marginBottom: "10px" }}
                    >
                      <h5 style={{ fontWeight: "bold", margin: "5px 0" }}>
                        {edu.degree}
                      </h5>
                      {edu.details.map((detail, detailIdx) => (
                        <p key={detailIdx} style={{ margin: "2px 0" }}>
                          <span style={{ fontWeight: "500" }}>
                            {detail.key}:
                          </span>{" "}
                          {detail.value}
                        </p>
                      ))}
                    </div>
                  ))}
                </div>
              )}
              {skillsLines.length > 0 && (
                <div className="skills-container">
                  <div className="skills-list">
                    <ul>
                      {skillsLines.map((skill, idx) => (
                        <li key={idx} className="skill-item">
                          {skill}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
              {message.resumes && message.resumes.length > 0 && (
                <div
                  className="candidates-grid"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "15px",
                    marginBottom: "20px",
                  }}
                >
                  {message.resumes.map((candidate, index) => (
                    <Card
                      key={`bot-response-${message.id}-candidate-${candidate.id}-${index}`}
                      name={
                        candidate.name ||
                        candidate.parsed_resume?.BasicInfo?.Name ||
                        "N/A"
                      }
                      email={
                        candidate.email ||
                        candidate.parsed_resume?.BasicInfo?.Email ||
                        "N/A"
                      }
                      phone={
                        candidate.phone ||
                        candidate.parsed_resume?.BasicInfo?.PhoneNumber ||
                        "N/A"
                      }
                      location={
                        candidate.city ||
                        candidate.parsed_resume?.BasicInfo
                          ?.CurrentLocationCity ||
                        "N/A"
                      }
                      role={
                        candidate.designation &&
                        candidate.designation.trim() !== ""
                          ? candidate.designation
                          : candidate.parsedResumeData?.CareerHistory
                                ?.JobDetails?.[0]?.JobTitle
                            ? candidate.parsedResumeData.CareerHistory
                                .JobDetails[0].JobTitle
                            : "Not specified"
                      }
                      experience={
                        candidate.parsed_resume?.BasicInfo?.YearsOfExperience ||
                        candidate.experience ||
                        "N/A"
                      }
                      skills={
                        candidate.parsed_resume?.Skills ||
                        candidate.skills ||
                        []
                      }
                      cardbackgroundColor="var(--body__background)"
                      cardColor="black"
                      skillbackgroundColor="#E0DEFF"
                      skillColor="#2D23DB"
                      viewEvent={() => handleCardView(candidate)}
                      showAssignJob={true}
                      assignJobEvent={() => handleAssignJobModal(candidate)}
                      matchPercentage={candidate.match_percentage}
                      fitness={candidate.fitness}
                    />
                  ))}
                </div>
              )}
              {message?.decorator &&
                message?.decorator?.type === "interview_schedule" && (
                  <div className="interview-schedule-container">
                    <div className="interview-schedule-header-container">
                      <h3 className="interview-schedule-header">
                        Interview Schedule
                      </h3>
                      <div className="interview-detail-item">
                        <img
                          src={interviewerIcon}
                          alt="Date"
                          style={{ width: "24px", height: "24px" }}
                        />
                        Interviewer :
                        <p>
                          {`${userDetails?.first_name} ${userDetails?.last_name}` ||
                            "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="interview-details">
                      <div className="interview-detail-item">
                        <img
                          src={candidateNameIcon}
                          alt="Date"
                          style={{ width: "24px", height: "24px" }}
                        />
                        Name:
                        <p>
                          {message.decorator.candidateDetails.name || "N/A"}
                        </p>
                      </div>
                      <div className="interview-detail-item">
                        <img
                          src={candidateEmailIcon}
                          alt="Date"
                          style={{ width: "24px", height: "24px" }}
                        />
                        Email:
                        <p>
                          {message.decorator.candidateDetails.email || "N/A"}
                        </p>
                      </div>
                      <div className="interview-detail-item">
                        <img
                          src={calenderIcon}
                          alt="Date"
                          style={{ width: "24px", height: "24px" }}
                        />
                        Date:
                        <p>
                          {message.decorator.parsedEventArgs?.date || "N/A"}
                        </p>
                      </div>
                      <div className="interview-detail-item">
                        <img
                          src={timerIcon}
                          alt="Time"
                          style={{ width: "24px", height: "24px" }}
                        />
                        Time:
                        <p>
                          {message.decorator.parsedEventArgs?.time
                            ? `${message.decorator.parsedEventArgs.time}`
                            : "N/A"}
                        </p>
                      </div>
                      <>
                        {message.decorator.parsedEventArgs?.meeting_link && (
                          <div className="interview-detail-item">
                            <img
                              src={timerIcon}
                              alt="Meeting Link"
                              style={{ width: "24px", height: "24px" }}
                            />
                            Meeting Link:
                            <p>
                              {message.decorator.parsedEventArgs.meeting_link ||
                                "N/A"}
                            </p>
                          </div>
                        )}
                      </>
                    </div>

                    <div className="card-interview-button-container">
                      <Button
                        label={"Cancel"}
                        isCancel={true}
                        disabled={isInterviewScheduled(message.id)}
                        event={() => cancelInterview(message.id)}
                        style={{
                          opacity: isInterviewScheduled(message.id) ? 0.6 : 1,
                          cursor: isInterviewScheduled(message.id)
                            ? "not-allowed"
                            : "pointer",
                          backgroundColor: isInterviewScheduled(message.id)
                            ? "#f5f5f5"
                            : "",
                          color: isInterviewScheduled(message.id)
                            ? "#a0a0a0"
                            : "",
                        }}
                      />
                      <Button
                        label={
                          isInterviewScheduling(message.id)
                            ? "Scheduling..."
                            : isInterviewScheduled(message.id)
                              ? "Interview Scheduled"
                              : "Schedule Interview"
                        }
                        event={() =>
                          scheduleInterview(message.id, message.decorator)
                        }
                        disabled={
                          isInterviewScheduling(message.id) ||
                          isInterviewScheduled(message.id)
                        }
                        style={{
                          opacity:
                            isInterviewScheduling(message.id) ||
                            isInterviewScheduled(message.id)
                              ? 0.6
                              : 1,
                          cursor:
                            isInterviewScheduling(message.id) ||
                            isInterviewScheduled(message.id)
                              ? "not-allowed"
                              : "pointer",
                          backgroundColor: isInterviewScheduled(message.id)
                            ? "#f5f5f5"
                            : "",
                          color: isInterviewScheduled(message.id)
                            ? "#a0a0a0"
                            : "",
                        }}
                      />
                    </div>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderRecommendedCandidates = () => {
    const botMessage = recommendedMessages.find((msg) => msg.sender === "bot");
    if (!botMessage) return null;
    if (
      isFetchingRecommendedCandidates ||
      (botMessage.isLoading && !candidatesCache.has(jobId))
    ) {
      return (
        <div
          className="cephea-loading-state"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "80px",
          }}
        >
          <VybogTALLoaderAnimation />
          <p style={{ marginTop: "8px", color: "var(--header__color)" }}>
            Finding your best matches…
          </p>
        </div>
      );
    }
    const hasCandidates = botMessage.resumes && botMessage.resumes.length > 0;
    const isNoCandidatesMessage =
      botMessage.text === "No recommended candidates found.";
    if (!hasCandidates && isNoCandidatesMessage) {
      return (
        <>
          <h4 style={{ textAlign: "center", marginBottom: "-20px" }}>
            There are no recommended candidates for this job!
          </h4>
          <AnimationPlayer
            animationSrc={NojobsAnimation}
            playerHeight="300px"
            playerWidth="300px"
          />
        </>
      );
    }
    const topFitRecommendedCandidates = botMessage.resumes.filter(
      (candidate) => String(candidate?.fitness || "").toLowerCase() === "top",
    );
    const selectedCandidateIds = new Set(
      selectedChatCan.map((candidate) => candidate.id),
    );
    const areAllSelectableCandidatesSelected =
      topFitRecommendedCandidates.length > 0 &&
      topFitRecommendedCandidates.every((candidate) =>
        selectedCandidateIds.has(candidate.id),
      );

    return (
      <div className="reccomend-candidate-search-results-container">
        <div className="bot-response-container">
          <div className="candidate-bot-response" style={{ width: "100%" }}>
            <div className="bot-message">
              <div className="reply-message">
                <div className="text-with-card-container">
                  {botMessage.isLoading === false &&
                  (botMessage.resumes.length === 0 ||
                    botMessage.text === "No recommended candidates found.") ? (
                    <>
                      <h4
                        style={{ textAlign: "center", marginBottom: "-20px" }}
                      >
                        There are no recommended candidates for this job!
                      </h4>
                      <AnimationPlayer
                        animationSrc={NojobsAnimation}
                        playerHeight="300px"
                        playerWidth="300px"
                      />
                    </>
                  ) : (
                    <div>
                      <div
                        className="recommendation-results-header"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: "var(--header__color)",
                            }}
                          >
                            Recommended Candidates
                          </span>
                          <span
                            style={{
                              fontSize: "13px",
                              color: "#6B7280",
                              marginTop: "5px",
                            }}
                          >
                            Select a candidate to ask VybogTAL about their fit,
                            skills, or experience
                          </span>
                        </div>

                        <div className="recommendation-action-bar">
                          {!isSelectMode && (
                            <Button
                              label="How is fit calculated?"
                              event={() => setShowMatchPercentagePopup(true)}
                              iconSrc={networkIcon}
                              iconWidth="18px"
                              className="recommend-action-button"
                            />
                          )}
                            {!isSelectMode ? (
                              <CustomTooltip
                                title={
                                  "You can select candidates and job blast"
                                }
                                arrow
                              >
                                <Button
                                  label="Select to Job Blast"
                                  event={handleToggleJobBlastSelectMode}
                                  iconSrc={jobsBlastIcon}
                                  iconWidth="16px"
                                  className="recommend-action-button"
                                />
                              </CustomTooltip>
                            ) : isJobBlastSelectModeActive &&
                            selectedChatCan.length > 0 && (
                              <CustomTooltip
                                title={
                                  "You can email this job to selected candidates"
                                }
                                arrow
                              >
                                <Button
                                  label={`Email Candidates (${selectedChatCan.length})`}
                                  event={() => {
                                    if (selectedChatCan.length > 0) {
                                      const candidatesWithoutEmail =
                                      selectedChatCan.filter(
                                          (c) =>
                                            !c.email ||
                                            (typeof c.email === "string" &&
                                              !c.email.trim()),
                                        );
                                      if (candidatesWithoutEmail.length > 0) {
                                        const names = candidatesWithoutEmail
                                          .map((c) => c.name || "Unknown")
                                          .join(", ");
                                        Toast(
                                          "error",
                                          `${names} ${
                                            candidatesWithoutEmail.length === 1
                                              ? "doesn't"
                                              : "don't"
                                          } have email.Please only select candidates with email.`,
                                        );
                                      } else {
                                        setIsEmailCampaignPopupOpen(true);
                                      }
                                    }
                                  }}
                                  iconSrc={jobsBlastIcon}
                                  iconWidth="16px"
                                  className="recommend-action-button"
                                />
                              </CustomTooltip>
                            )}
                          {!isSelectMode ? (
                            <CustomTooltip
                              title={
                                "You can select upto 10 candidates to chat"
                              }
                              arrow
                            >
                              <Button
                                label="Select to Chat"
                                event={handleToggleSelectMode}
                                iconSrc={VybogTALWhiteIcon}
                                iconWidth="16px"
                                className="recommend-action-button"
                              />
                            </CustomTooltip>
                          ) : (
                            <div className="recommend-selection-actions">
                              {!isJobBlastSelectModeActive &&
                              selectedChatCan.length > 0 && (
                                <span className="recommend-selected-jobs-count">
                                  {selectedChatCan.length === 1
                                    ? `Selected Candidate (${selectedChatCan.length})`
                                    : `Selected Candidates (${selectedChatCan.length})`}
                                  <Badge
                                    badgeContent="BETA"
                                    sx={{
                                      "& .MuiBadge-badge": {
                                        fontSize: "10px",
                                        height: "20px",
                                        marginTop: "-2px",
                                        marginLeft: "5px",
                                        minWidth: "32px",
                                        padding: "2px 8px",
                                        backgroundColor: "#fff4e5",
                                        color: "#ffa408",
                                        border: "1px solid #ffa408",
                                        position: "static",
                                        transform: "none",
                                        borderRadius: "12px",
                                      },
                                    }}
                                  />
                                </span>
                              )}
                              {isJobBlastSelectModeActive && (
                                <Button
                                  label={
                                    areAllSelectableCandidatesSelected
                                      ? "Deselect All"
                                      : "Select All ( Top Fit ) "
                                  }
                                  event={() =>
                                    handleSelectAllRecommendedCandidates(
                                      botMessage.resumes,
                                    )
                                  }
                                  disabled={
                                    topFitRecommendedCandidates.length === 0
                                  }
                                  className="recommend-action-button"
                                />
                              )}
                              <Button
                                label="Cancel"
                                event={() => {
                                  handleToggleSelectMode();
                                  setIsJobBlastSelectModeActive(false);
                                }}
                                isCancel={true}
                                className="recommend-action-button"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="recommended-candidates-grid">
                        {botMessage.resumes.map((candidate, index) => {
                          const isSelected =
                            isSelectMode &&
                            selectedChatCan.some((c) => c.id === candidate.id);
                          return (
                            <div
                              className={`candidate-card-outer-container ${
                                isSelected ? "selected" : ""
                              }`}
                              onClick={(e) => {
                                if (isSelectMode) {
                                  handleCardSelect(candidate, e);
                                }
                              }}
                              style={{
                                cursor: isSelectMode ? "pointer" : "default",
                              }}
                            >
                              <Card
                                key={`recommended-candidate-${botMessage.id}-${candidate.id}-${index}`}
                                name={candidate.name || "N/A"}
                                email={candidate.email || "N/A"}
                                phone={candidate.phone || "N/A"}
                                location={
                                  candidate.city ||
                                  candidate.parsed_resume?.BasicInfo
                                    ?.CurrentLocationCity ||
                                  "N/A"
                                }
                                role={
                                  candidate.designation &&
                                  candidate.designation.trim() !== ""
                                    ? candidate.designation
                                    : candidate.parsedResumeData?.CareerHistory
                                          ?.JobDetails?.[0]?.JobTitle
                                      ? candidate.parsedResumeData.CareerHistory
                                          .JobDetails[0].JobTitle
                                      : "Not specified"
                                }
                                experience={
                                  candidate.years_of_experience ||
                                  (candidate.parsed_resume?.BasicInfo
                                    ?.YearsOfExperience
                                    ? parseInt(
                                        candidate.parsed_resume.BasicInfo
                                          .YearsOfExperience,
                                      )
                                    : null) ||
                                  "N/A"
                                }
                                skills={
                                  candidate.parsed_resume?.Skills ||
                                  candidate.skills ||
                                  []
                                }
                                cardbackgroundColor="var(--body__background)"
                                cardColor="black"
                                skillbackgroundColor="#E0DEFF"
                                skillColor="#2D23DB"
                                viewEvent={() => handleCardView(candidate)}
                                showAssignJob={true}
                                assignJobEvent={() =>
                                  handleAssignJobModal(candidate)
                                }
                                isSelectMode={isSelectMode}
                                isSelected={isSelected}
                                handleCardSelect={(e) =>
                                  handleCardSelect(candidate, e)
                                }
                                matchPercentage={candidate.match_percentage}
                                fitness={candidate.fitness}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleSearchBoxCollapse = (isCollapsed) => {
    setIsSearchBoxCollapsed(isCollapsed);
  };

  const hasRecommendedCandidates =
    candidatesCache.has(jobId) && candidatesCache.get(jobId).length > 0;

  const renderChatMessages = () => {
    return (
      <div className="chat-messages-container">
        {searchMessages.map((message, index) => (
          <div
            key={`chat-msg-${message.id}-${index}`}
            className={`message-wrapper ${message.sender}`}
          >
            {message.sender === "user" ? (
              <div className="user-message-container">
                <div className="user-message-content">
                  <p className="user-message-query-text">{message.text}</p>
                </div>
              </div>
            ) : (
              renderBotResponse(message)
            )}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
    );
  };

  const fetchVendors = async (query) => {
    try {
      setVendorOptionLoading(true);
      const res = await get(
        VYLABS_BASE_URL,
        `${VENDORS_SEARCH}?vendor_name=${encodeURIComponent(query)}`,
      );
      setVendorList(
        (res.vendors || [])
          .filter((v) => v.id && v.name)
          .map((v) => ({
            label: v.contact_person
              ? `${v.name} - ${v.contact_person}`
              : v.name,
            value: v.id,
          })),
      );
    } catch {
      setVendorList([]);
    } finally {
      setVendorOptionLoading(false);
    }
  };
  const handleVendorInputChange = (_, value) => {
    if (value && value.length >= 3) fetchVendors(value);
    else setVendorList([]);
  };
  const handleEditCandidate = () => {
    const getValidExperience = (value) => {
      const num = Number(value);

      if (isNaN(num)) return "";
      if (num < 0) return 0;
      return num;
    };

    let experienceValue = "";
    const directExp = getValidExperience(
      selectedCandidate?.years_of_experience,
    );

    const parsedExp = getValidExperience(
      selectedCandidate?.parsedResumeData?.BasicInfo?.YearsOfExperience,
    );

    if (directExp !== "") {
      experienceValue = directExp;
    } else if (parsedExp !== "") {
      experienceValue = parsedExp;
    }
    const candidateWithFormattedSkills = {
      ...selectedCandidate,
      name: selectedCandidate.name || selectedCandidate.BasicInfo?.Name || "",
      email:
        selectedCandidate.email || selectedCandidate.BasicInfo?.Email || "",
      secondaryEmail:
        selectedCandidate.secondaryEmail ||
        selectedCandidate.BasicInfo?.secondaryEmail ||
        "",
      phone:
        selectedCandidate.phone ||
        selectedCandidate.BasicInfo?.PhoneNumber ||
        "",
      secondaryPhone:
        selectedCandidate.secondaryPhone ||
        selectedCandidate.BasicInfo?.secondaryPhone ||
        "",
      city:
        selectedCandidate.city ||
        selectedCandidate.BasicInfo?.CurrentLocationCity ||
        "",
      state:
        selectedCandidate.state ||
        selectedCandidate.BasicInfo?.CurrentLocationState ||
        "",
      country:
        selectedCandidate.country ||
        selectedCandidate.BasicInfo?.CurrentLocationCountry ||
        "",
      skills: Array.isArray(selectedCandidate.skills)
        ? selectedCandidate.skills
        : selectedCandidate.parsedResumeData?.Skills || [],
      vendorID:
        selectedCandidate.vendorID ||
        selectedCandidate.BasicInfo?.vendorID ||
        "",
      designation:
        selectedCandidate.designation?.trim() ||
        selectedCandidate.parsedResumeData?.CareerHistory?.JobDetails?.[0]
          ?.JobTitle ||
        "",
      experience: experienceValue,
      lineAddress1:
        selectedCandidate.lineAddress1 ||
        selectedCandidate.BasicInfo?.LineAddress1 ||
        "",
      lineAddress2:
        selectedCandidate.lineAddress2 ||
        selectedCandidate.BasicInfo?.LineAddress2 ||
        "",
      zipCode:
        selectedCandidate.zipCode || selectedCandidate.BasicInfo?.ZipCode || "",
      preferredSalary:
        selectedCandidate.preferredSalary ||
        selectedCandidate.BasicInfo?.PreferredSalary ||
        "",
    };
    setOriginalCandidateData({ ...selectedCandidate });
    setEditedCandidateData(candidateWithFormattedSkills);
    setIsEditingCandidate(true);
    setEmailError("");
    setEmailTouched(false);
  };

  const resetCandidateEdit = () => {
    if (originalCandidateData) {
      setSelectedCandidate(originalCandidateData);
    }
    setIsEditingCandidate(false);
    setOriginalCandidateData(null);
    setEditedCandidateData(null);
    setEmailError("");
    setEmailTouched(false);
  };

  const handleCandidateChange = (data) => {
    setEditedCandidateData((prev) => {
      const updated = {
        ...prev,
        ...data,
      };
      return updated;
    });
  };

  const saveCandidateChanges = async () => {
    if (!editedCandidateData) {
      Toast("error", "No changes to save");
      return;
    }

    const email =
      editedCandidateData.email !== undefined
        ? editedCandidateData.email
        : selectedCandidate.email || "";

    if (!email.trim()) {
      setEmailError("Email is required");
      setEmailTouched(true);
      Toast("error", "Email is required");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format");
      setEmailTouched(true);
      Toast("error", "Please fill all required fields correctly");
      return;
    }

    setEmailError("");
    setEmailTouched(false);

    try {
      const candidateData = { id: selectedCandidate.id };

      Object.keys(editedCandidateData).forEach((key) => {
        const newValue = editedCandidateData[key];
        const oldValue = selectedCandidate[key];

        const isChanged = Array.isArray(newValue)
          ? JSON.stringify(newValue) !== JSON.stringify(oldValue)
          : newValue !== oldValue;

        if (
          isChanged &&
          newValue !== undefined &&
          newValue !== null &&
          newValue !== ""
        ) {
          candidateData[key] = newValue;
        }
      });

      if (Object.keys(candidateData).length === 1) {
        Toast("error", "No changes to save");
        return;
      }

      Object.keys(candidateData).forEach((key) => {
        if (key === "preferredSalary") {
          candidateData[key] = Number(candidateData[key]);
        }
      });

      if (candidateData.experience !== undefined) {
        candidateData.yearsOfExperience = Number(candidateData.experience);
        delete candidateData.experience;
      }

      const response = await post(
        VYLABS_BASE_URL,
        UPDATE_CANDIDATE_DETAILS,
        candidateData,
      );

      if (response) {
        const updatedCandidate = {
          ...selectedCandidate,
          ...candidateData,
        };

        if (
          candidateData.vendorID !== undefined &&
          candidateData.vendorID !== selectedCandidate.vendorID
        ) {
          if (candidateData.vendorID) {
            try {
              const vendorResponse = await get(
                VYLABS_BASE_URL,
                `${GET_VENDOR_DETAILS_BY_ID}?id=${candidateData.vendorID}`,
              );
              updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
              setAssignedVendor(vendorResponse);
            } catch (err) {
              console.error("Error fetching vendor details:", err);
              updatedCandidate.vendorDetails = null;
              setAssignedVendor(null);
            }
          } else {
            updatedCandidate.vendorDetails = null;
          }
        }

        setSelectedCandidate(updatedCandidate);
        setIsEditingCandidate(false);
        setOriginalCandidateData(null);
        setEditedCandidateData(null);
        Toast("success", "Candidate updated successfully");

        if (isAllCandidatesActive) {
          setAllCanList((prev) =>
            prev.map((candidate) =>
              candidate.id === updatedCandidate.id
                ? updatedCandidate
                : candidate,
            ),
          );
        } else {
          setMyCanList((prev) =>
            prev.map((candidate) =>
              candidate.id === updatedCandidate.id
                ? updatedCandidate
                : candidate,
            ),
          );
        }
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      const backendMessage =
        error?.response?.data?.message ||
        (typeof error?.response?.data === "string"
          ? error.response.data
          : null) ||
        error.message ||
        "Failed to update candidate";
      Toast("error", backendMessage);
    }
  };

  return (
    <div className="assign-candidate-outer">
      {hasSearched ? (
        <div className="search-results-container">
          {renderChatMessages()}
          <div className="search-box-bottom">
            {!hideSearchBox && (
              <RecommendedSearchBox
                isDarkMode={isDarkMode}
                isRecommendedPage={true}
                outerStyle={{ padding: "15px" }}
                recommendedSearchBoxTitle="VybogTAL Chat"
                askMeAnythingPlaceholder="E.g. Is [Candidate Name] a good fit for this role?"
                buttonLabel="Chat"
                TextAreaStyle={{ height: "55px" }}
                inputsectionstylewrap={{ paddingBottom: "20px" }}
                inputsectionstyle={{ paddingTop: "1px" }}
                askMeAnythingValue={formik.values.askmeanything}
                jobDescriptionOnChange={formik.handleChange}
                onAskChange={(e) =>
                  formik.setFieldValue("askmeanything", e.target.value)
                }
                onSubmit={handleCandidateConversation}
                onClear={handleClearSearch}
                showAttachResume={false}
                isCollapsed={isSearchBoxCollapsed}
                onCollapseChange={handleSearchBoxCollapse}
                showJobDescriptionField={false}
                submitErrorMessage="Please provide a search query."
                askmeanythingOnKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    handleCandidateConversation();
                  }
                }}
                isSearchLoading={isBotProcessing}
                showBadge={true}
              />
            )}
          </div>
        </div>
      ) : (
        <div>
          {isBotProcessing ? (
            <div className="loading-state">
              <div className="skeleton-grid">
                {Array.from({ length: 4 }).map((_, idx) => (
                  <DynamicSkeleton
                    key={`skeleton-${idx}`}
                    variant="rectangular"
                    dimensions={{
                      width: "93%",
                      height: "180px",
                      sx: {
                        borderRadius: "16px",
                        border: "1px solid #e0e0e0",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        padding: "16px",
                      },
                    }}
                  />
                ))}
              </div>
            </div>
          ) : (
            recommendedMessages.length > 0 && renderRecommendedCandidates()
          )}
          {hasRecommendedCandidates &&
            !hasSearched &&
            !isBotProcessing &&
            recommendedMessages.length > 0 &&
            !hideSearchBox &&
            selectedChatCan.length !== 0 &&
            !isJobBlastSelectModeActive && (
              <div className="search-box-bottom">
                <RecommendedSearchBox
                  isDarkMode={isDarkMode}
                  isRecommendedPage={true}
                  outerStyle={{ padding: "15px" }}
                  recommendedSearchBoxTitle="Candidate Search"
                  askMeAnythingPlaceholder="Search for 'Frontend developer with 6 years of experience'"
                  buttonLabel="Chat"
                  TextAreaStyle={{ height: "55px" }}
                  inputsectionstylewrap={{ paddingBottom: "20px" }}
                  inputsectionstyle={{ paddingTop: "1px" }}
                  askMeAnythingValue={formik.values.askmeanything}
                  jobDescriptionOnChange={formik.handleChange}
                  onAskChange={(e) =>
                    formik.setFieldValue("askmeanything", e.target.value)
                  }
                  onSubmit={handleCandidateConversation}
                  onClear={handleClearSearch}
                  showAttachResume={false}
                  isCollapsed={isSearchBoxCollapsed}
                  onCollapseChange={handleSearchBoxCollapse}
                  showJobDescriptionField={false}
                  submitErrorMessage="Please provide a search query."
                  showBadge={true}
                  askmeanythingOnKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleCandidateConversation();
                    }
                  }}
                />
              </div>
            )}
            {isEmailCampaignPopupOpen && (
              <SidePopup
              isOpen={isEmailCampaignPopupOpen}
              onClose={() => setIsEmailCampaignPopupOpen(false)}
              sidePopupWidth="50%"
              title={
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <img src={EmailCampaignIcon} alt="" />
                    <span
                      style={{
                        color: "#534BDB",
                        fontSize: "18px",
                        fontWeight: "600",
                      }}
                    >
                      Email Campaign
                    </span>
                  </div>
    
                  <span
                    style={{
                      color: "#6B7280",
                      fontSize: "12px",
                      marginLeft: "50px",
                    }}
                  >
                    Send job opportunities to selected candidates
                  </span>
                </div>
              }
            >
              <JobsBlastEmailCampaign
                selectedCandidates={selectedChatCan}
                isEmailPreviewOpen={isEmailPreviewOpen}
                setIsEmailPreviewOpen={setIsEmailPreviewOpen}
                setCanPreview={setCanPreview}
                jobId={jobId}
                jobTitle={jobTitle}
                onCancel={() => setIsEmailCampaignPopupOpen(false)}
              />
            </SidePopup>
            )}
        </div>
      )}

      <SidePopup
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Candidate Details"
        sidePopupWidth="85%"
      >
        <CandidateDetailsContainer
          candidate={selectedCandidate}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
          hasSearched={hasSearched}
          hasRecommendedCandidates={hasRecommendedCandidates}
          isEditingCandidate={isEditingCandidate}
          handleEditCandidate={handleEditCandidate}
          saveCandidateChanges={saveCandidateChanges}
          resetCandidateEdit={resetCandidateEdit}
          handleCandidateChange={handleCandidateChange}
          editedCandidateData={editedCandidateData}
          vendorList={vendorList}
          vendorOptionLoading={vendorOptionLoading}
          handleVendorInputChange={handleVendorInputChange}
          assignedVendor={assignedVendor}
        />
      </SidePopup>
      <CandidatesAssignJob
        isOpen={isAssignJobModalOpen}
        setAssignJobModalOpen={setAssignJobModalOpen}
        selectedCandidates={candidateToAssign ? [candidateToAssign] : []}
        jobId={jobId}
        jobTitle={jobTitle}
      />
      <ConfirmationPopup
        isOpen={openConversationLimitPopup}
        onConfirm={() => {
          handleClearSearch();
          setOpenConversationLimitPopup(false);
        }}
        title="Conversation limit reached."
        message="You have reached the limit of this conversation. Please start a new one"
        confirmLabel="New Chat"
        cancelLabel=""
      />
      {showMatchPercentagePopup && (
        <MatchPercentage
          isRerank
          onClose={() => setShowMatchPercentagePopup(false)}
        />
      )}
    </div>
  );
}

export default RecommendCandidates;
